// eslint-disable-next-line import/prefer-default-export
export const SET_ANNOUNCEMENTS = 'SET_ANNOUNCEMENTS';
export const GET_ANNOUNCEMENTS_PENDING = 'GET_ANNOUNCEMENTS_PENDING';
export const GET_ANNOUNCEMENTS_SUCCESS = 'GET_ANNOUNCEMENTS_SUCCESS';
export const GET_ANNOUNCEMENTS_ERROR = 'GET_ANNOUNCEMENTS_ERROR';

export const SET_MY_ACTIVITY = 'SET_MY_ACTIVITY';
export const GET_MY_ACTIVITY_PENDING = 'GET_MY_ACTIVITY_PENDING';
export const GET_MY_ACTIVITY_SUCCESS = 'GET_MY_ACTIVITY_SUCCESS';
export const GET_MY_ACTIVITY_ERROR = 'GET_MY_ACTIVITY_ERROR';
